export const roundAccurately = (value: any, decimalPlaces: any) => {
  return Number(
    Math.round((value + "e" + decimalPlaces) as any) + "e-" + decimalPlaces
  );
};
